import axios from "axios"

export class Locations {
    cidades(params = {}) {
        return axios.get(window.apis.cidades, { params })
    }

    bairros(params = {}) {
        return axios.get(window.apis.bairros, { params })
    }
}
